import {fetchArticles} from "../components/news/_article.fetch";

function getActiveCategoryButton() {
  return document.querySelector('[data-category].is--active');
}

export const initCategoryFilter = () => {
  const categoryFilterButtons = document.querySelectorAll('[ data-category]'),
    categoryResetButton = document.querySelector('[data-filter="reset"]');

  if(getActiveCategoryButton()) categoryResetButton.classList.remove('is--hidden');

  categoryFilterButtons.forEach(categoryButton => {

    categoryButton.addEventListener('click', () => {
      const activeCategory = getActiveCategoryButton();

      if (!activeCategory) {
        categoryButton.classList.add('is--active');
        categoryResetButton.classList.remove('is--hidden');
        return fetchArticles();
      }

      if (activeCategory === categoryButton) {
        activeCategory.classList.remove('is--active')
        categoryResetButton.classList.add('is--hidden');
        return fetchArticles();
      } else {
        activeCategory.classList.remove('is--active');
        categoryButton.classList.add('is--active')
        return fetchArticles();
      }
    })

    categoryResetButton.addEventListener('click', () => {

      const activeCategory = document.querySelector('[data-category].is--active');
      if (activeCategory) {
        activeCategory.classList.remove('is--active');
        categoryResetButton.classList.add('is--hidden');
        return fetchArticles();
      }

    })
  })
}
